import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=822a469a&scoped=true&"
import script from "./Toolbar.vue?vue&type=script&lang=ts&"
export * from "./Toolbar.vue?vue&type=script&lang=ts&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=822a469a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822a469a",
  null
  
)

export default component.exports